import { autoinject } from 'aurelia-framework';
import { ApiService } from '../../utils/api-service';
import { IText } from '../../utils/translator';

export class ScopeType {
	id: string;
	name: IText;
	scopeTypeGroupId: string;
	sortOrder: number;
}

@autoinject
export class ScopeTypeService {
	constructor(private api: ApiService) {}

	async getScopeTypes() : Promise<ScopeType[]> {
		return this.api.fetchJson('scope-types');
	}
}
